var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import StdpcSpecChange from '../stdpc/spec_change';
import ProductSeller from '../product_seller';
import HappyInfo from '../happy_info';
import Youtube from '../youtube';
import Spec from '../spec';
import Catalog from '../catalog';
import Review from '../review';
import Qna from '../qna';
import CheckList from '../check_list';
import NaverPowerLink from '../naverPowerLink';
import SpecChangeNotMiniShop from "../summary_info/detail/notminishop/spec_shange_not_minishop";
import BundleGroup from "./bundle_group/bundle_group.container";
var TabContents = function () {
    var _a;
    var item = useSelector(function (state) { return state.product.item; });
    var isStdpc = (item === null || item === void 0 ? void 0 : item.cate_id.toString().slice(0, 1)) === '2';
    var isMinishop = item === null || item === void 0 ? void 0 : item.minishop;
    var priceDataNumber = useSelector(function (state) { return state.product.priceStateNumber; });
    var isPopUp = useSelector(function (state) { return state.product.isPopUp; });
    var isBundleShow = !!((_a = item === null || item === void 0 ? void 0 : item.bundle_list) === null || _a === void 0 ? void 0 : _a.length) ? true : false;
    return (React.createElement(React.Fragment, null, !item && isPopUp
        ? React.createElement(Loading, null)
        :
            React.createElement(Style, { isPopUp: isPopUp },
                (item && isBundleShow && !isPopUp) && React.createElement(BundleGroup, { item: item, isMinishop: isMinishop }),
                ((!isMinishop || (isMinishop && isStdpc)) && !isPopUp) && (React.createElement(Section, { className: "tab_contents_target1" }, (isStdpc && isMinishop) ? (React.createElement(StdpcSpecChange, null)) : (isStdpc ? React.createElement(SpecChangeNotMiniShop, null) :
                    (priceDataNumber === 3 ?
                        React.createElement(React.Fragment, null,
                            React.createElement(ProductSeller, null),
                            " ",
                            React.createElement(NaverPowerLink, null),
                            " ",
                            React.createElement(HappyInfo, null),
                            " ") :
                        React.createElement(React.Fragment, null,
                            React.createElement(NaverPowerLink, null),
                            " "))))),
                isPopUp && React.createElement(EmptyBox, null),
                item &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Section, { className: "tab_contents_target2" },
                            React.createElement("div", { className: "youtube_spec_area" },
                                React.createElement(Youtube, null),
                                React.createElement(Spec, null),
                                " "),
                            React.createElement(Catalog, null)),
                        React.createElement(Section, { className: "tab_contents_target3" },
                            React.createElement(Review, null),
                            " "),
                        React.createElement(Section, { className: "tab_contents_target4" },
                            React.createElement(Qna, null),
                            " "),
                        React.createElement(Section, { className: "tab_contents_target5" },
                            React.createElement(CheckList, null),
                            " ")))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .youtube_spec_area {\n         margin: 60px 0 0;\n        ", "\n    }\n"], ["\n    .youtube_spec_area {\n         margin: 60px 0 0;\n        ", "\n    }\n"])), function (props) { return props.isPopUp ? '' : 'border-top: 2px solid #333;'; });
var Section = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var EmptyBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    height: 20px;\n"], ["\n    width: 100%;\n    height: 20px;\n"
    /**
     * 팝업 노출 될 경우 로딩 이미지 노출
     * @constructor
     */
])));
/**
 * 팝업 노출 될 경우 로딩 이미지 노출
 * @constructor
 */
var Loading = function () {
    return (React.createElement(Load, null,
        React.createElement("img", { className: "loadingCycle", src: "".concat(process.env.REACT_APP_CDN_IMG, "/img_static/img_pres/_v5/happy_loading_5.gif"), width: "60", height: "69" })));
};
var Load = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n"], ["\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n"])));
export default memo(TabContents);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/tab/contents.tsx
// module id = 220
// module chunks = 0